import { currentCodeVersion } from "../../appConstants"
import { CodesVersion } from "../../enum/codesVersionEnum"
import { ProjectStatusEnum } from "../../enum/projectStatusEnum"
import { stringToDate } from "../../services/date-service"
import { Address } from "../address"
import { ProjectCalculationStatus } from "./ProjectCalculationStatus"

export class Project {
  id: string | undefined
  organizationId = ""
  name = ""
  businessCode = ""
  licenceDate?: Date
  address: Address = new Address()
  codesVersion: CodesVersion = currentCodeVersion
  status: ProjectStatusEnum = ProjectStatusEnum.IN_PROGRESS
  coverImgFileName = ""
  coverImgFileType = ""
  createdByUser = ""
  lastModifiedDate?: Date
  departmentId = ""
  hasCoverImg = false
  seismicZone = false
  folder = ""
  calculationStatus = ProjectCalculationStatus.NOT_IN_PROGRESS

  static fromDto(data: any): Project {
    const project = data as Project
    if (data === undefined) {
      return new Project()
    }
    project.organizationId = data.organizationId ?? ""
    project.name = data.name ?? ""
    project.businessCode = data.businessCode ?? ""
    project.licenceDate = stringToDate(data.licenceDate)
    project.codesVersion = data.codesVersion ?? CodesVersion.VERSION_1_8
    project.lastModifiedDate = stringToDate(data.lastModifiedDate)

    return project
  }
}
